import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  StyledKurultaiBadge,
  StyledKurultaiFlag,
  StyledKurultaiText,
  StyledKurultaiTitle,
  StyledKurultaiDate,
  StyledKurultaiAccent,
  StyledKurultaiCheck
} from './HomeKurultaiBannerStyles';
import { isKurultaiBannerActive } from '../../../utils/kurultaiBanner';
import kzFlagRibbon from '../../../_assets/images/kzFlagRibbon.png';
import kurultaiCheck from '../../../_assets/images/kurultaiCheck.png';
import '../HomeTranslate';

function HomeKurultaiBanner() {
  const { t } = useTranslation();
  const [active, setActive] = useState(isKurultaiBannerActive);

  useEffect(() => {
    if (!active) return undefined;
    const timer = setInterval(() => setActive(isKurultaiBannerActive()), 60000);
    return () => clearInterval(timer);
  }, [active]);

  if (!active) return null;

  return (
    <StyledKurultaiBadge>
      <StyledKurultaiFlag src={kzFlagRibbon} alt={t('home_kurultai_flag_alt')} />
      <StyledKurultaiText>
        <StyledKurultaiTitle>{t('home_kurultai_title')}</StyledKurultaiTitle>
        <StyledKurultaiDate>
          <StyledKurultaiAccent>{t('home_kurultai_date')}</StyledKurultaiAccent>
          <StyledKurultaiCheck src={kurultaiCheck} alt="" aria-hidden="true" />
        </StyledKurultaiDate>
      </StyledKurultaiText>
    </StyledKurultaiBadge>
  );
}

export default HomeKurultaiBanner;
